module.exports = __webpack_public_path__ + "img/al.6a0f1821.svg";